import { StorableObject } from "@app/core/storable-object";

export class CourseraRegistration extends StorableObject {
    constructor(public personId: string) {
        super();
    }
}